import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDLE, LOADING } from "../../constants";
import { getAccountsByUnit } from "../../redux/core/accounts";
import { getActiveBuildingsByUserAccess } from "../../redux/core/buildings";
import { getAllOrganizations } from "../../redux/core/organizations";
import { getFromServerTopic } from "../../utility/slice";
import { getAllCurtailmentProgramAdmins } from "../programs/programSlice";

const SLICE = "demandResponse";

const action = (name) => `${SLICE}/${name}`;

// Capture Groups are $1: Date yyyy-mm-dd, $2: Time hh:mm or hh:mm:ss, $3: Milliseconds .vvv
export const reDateTime =
  /^([0-9]{4}-[0-9]{2}-[0-9]{2})[ T]?([0-9]{2}:[0-9]{2}(?::[0-9]{2})?)?(\.[0-9]{3})?Z?$/;

function resolveDate(value) {
  return value ? value?.replace(reDateTime, "$1T$2") : value;
}

export const getFromServer = (action, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, payloadFn });

export const getAllCurtailmentResources = getFromServer("getAllResources");

export const saveCurtailmentResource = getFromServer(
  "saveResource",
  async (payload) => payload,
);

export const getAllProgramAdmins = createAsyncThunk(
  action("getAllCurtailmentProgramAdmins"),
  async (arg, { dispatch, getState }) => {
    await dispatch(getAllCurtailmentProgramAdmins());
    return getState().curtailmentPrograms;
  },
);

export const getAllSites = createAsyncThunk(
  action("getAllSites"),
  async (arg, { dispatch, getState }) => {
    await dispatch(getActiveBuildingsByUserAccess());
    return getState().buildings;
  },
);
export const getAllOrgs = createAsyncThunk(
  action("getAllOrganizations"),
  async (arg, { dispatch, getState }) => {
    await dispatch(getAllOrganizations());
    return getState().organizations;
  },
);
export const getAllAccounts = createAsyncThunk(
  action("getAllAccounts"),
  async (arg, { dispatch, getState }) => {
    await dispatch(getAccountsByUnit({ unitId: 1 }));
    return getState().accounts;
  },
);

export const initializeCurtailmentResourcePage = createAsyncThunk(
  action("initializeCurtailmentResourcePage"),
  async (payload, { dispatch }) =>
    Promise.all([
      dispatch(getAllCurtailmentResources()),
      dispatch(getAllSites()),
      dispatch(getAllOrganizations()),
      dispatch(getAllAccounts()),
      dispatch(getAllProgramAdmins()),
    ]),
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    accounts: [],
    buildings: [],
    organizations: [],
    programAdmins: [],
    resources: [],
    status: LOADING,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCurtailmentResources.fulfilled, (state, action) => {
        const data = action.payload.response;
        for (let i = 0; i < data.length; i++) {
          data[i].effectiveStart = resolveDate(data[i].effectiveStart);
          data[i].effectiveEnd = resolveDate(data[i].effectiveEnd);
        }
        state.resources = data;
      })
      .addCase(saveCurtailmentResource.fulfilled, (state, action) => {
        const { resource, method } = action.payload.response;
        if (method === "save") {
          state.resources = [
            ...state.resources,
            { ...resource, resourceId: action.payload.response.insertId },
          ];
        } else {
          state.resources = [
            ...state.resources.filter(
              (_resource) => _resource.resourceId !== resource.resourceId,
            ),
            resource,
          ];
        }
      })
      .addCase(getAllSites.fulfilled, (state, action) => {
        state.buildings = action.payload.buildings;
      })
      .addCase(getAllOrganizations.fulfilled, (state, action) => {
        state.organizations = action.payload.response;
      })
      .addCase(getAllAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload.accounts;
      })
      .addCase(getAllProgramAdmins.fulfilled, (state, action) => {
        state.programAdmins = action.payload.programAdmins;
      })
      .addCase(initializeCurtailmentResourcePage.fulfilled, (state) => {
        state.status = IDLE;
      });
  },
});

export default slice.reducer;
